module.exports = {
      id: "fa-caretup-usage",
      viewBox: "0 0 320 512",
      url: "/assets/icons/" + "sprite.ecb5ac98d0f5af61574884cef75bbacd.svg#fa-caretup",
      toString: function () {
        return this.url;
      }
    }